<template>
<div :class="['three-dot-field', isOpen ? 'open' : '']">
  <div v-if="!isOpen" @click="openField" class="clickable p-1">
      <icon :type="dotIcon" />
  </div>
  <div
      :style="{minWidth: isOpen ? minWidth : 0, minHeight: isOpen ? minHeight : 0}"
      :class="['three-dot-field-content', isOpen ? 'open' : '', openDirection]">
    <div v-if="isOpen" @click="isOpen = false" class="closer clickable p-1">
      <icon type="xmark" />
    </div>
    <slot v-if="isOpen"/>
  </div>
</div>
</template>

<script>
import Icon from "@/components/Icon.vue";
export default {
  name: "ThreeDotField",
  components: {Icon},
  props: {
    minWidth: {type: String, required: false, default: '350px'},
    minHeight: {type: String, required: false, default: '100px'},
    dotIcon: {type: String, required: false, default: 'circle-ellipsis'},
    openDirection: {type: String, required: false, default: 'left'},
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    openField() {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>

<style scoped lang="scss">
.three-dot-field {
  position: relative;
  display: inline-block;
  .three-dot-field-content {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    margin-top: 0.5rem;
    min-width: 0;
    min-height: 0;
    &.right {
      right: auto;
      left: 0;
    }
    &.open {
      padding: 15px;
      background-color: var(--vform-editor-ui-secondary-color);
      border: 1px solid rgba(255,255,255,0.3);
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    }
  }
}
.closer {
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>